module.exports = __webpack_public_path__ + "static/media/exclamation.91179a7d.svg";